import firestore from './firestore.js'

export default {
  state: () => ({
  }),
  getters: {
    studentSubjects(state, getters, rootState) {
      // Subjects across all of their lecturers
      let subjects = []
      if (rootState.firestore.dbRoot.lecturers) {
        rootState.firestore.dbRoot.lecturers.forEach(lecturer => {
          if (lecturer.subjects) {
            subjects = subjects.concat(lecturer.subjects)
          }
        })
      }
      return subjects
    }
  },
  mutations: {
  },
  actions: {

    // STUDENT ACTIONS
    async addAttempt({ getters }, attemptData) {
      // parentPath is the path to a teachingSession
      // navigate to the parent lecturer in order to add the attempt
      const teachingSession = getters.db.doc(attemptData.parentPath)
      const lecturerRef = teachingSession.parent.parent
      await lecturerRef.collection('attempts').add(attemptData)
    },

    bindStudentData({ commit, getters }) {
      // Only allow this binding to be created once
      if (!getters.singletonGuards.includes('STUDENT_BIND')) {
        commit('ADD_SINGLETON_GUARD', 'STUDENT_BIND')

        commit('ADD_ROOT_TO_DIRECTORY')
        // Subscribe to new attempts being added and fetch teachingSession, tutorial, subject, lecturer
        this.subscribe(async ( mutation ) => {
          if (mutation.type === 'ADD_DOC' && mutation.payload.ref.parent.id === 'attempts') {

            // Check if hierarchy of teachingSession > tutorial > subject > lecturer has already loaded
            // Create a function that will recurse its way down the hierarchy
            const recurseDown = async (parentPath) => {
              // If the parent has not been loaded then fetch it
              if (!Object.prototype.hasOwnProperty.call(getters.directory, parentPath)) {
                const currentObj = await getters.db.doc(parentPath).get()

                // Now recurse to check the parent(s)
                await recurseDown(currentObj.data().parentPath)

                // Add this doc once recursion has finished
                commit('ADD_DOC', currentObj)

                // Return true to indicate that parents were added
                return true
              }
            }

            // Kick off the recursion by searching for the teachingSession
            const parentsAdded = await recurseDown(mutation.payload.data().parentPath)

            // If parents had to be added then that means attempt to ADD_DOC failed
            if (parentsAdded) {
              // Add the attempt doc again so it gets inserted into the hierarchy
              commit('ADD_DOC', mutation.payload)
            }
          }
        })

        // Now that listener is configured, bind the students attempts
        firestore.bindFirestoreRef(commit, getters.db.collectionGroup('attempts').where('studentId', '==', getters.user.id))
      }
    },
  }
}
